import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
// Defers <Navigate> until after client-side hydration to avoid StaticRouter warnings
var ClientRedirect = function (_a) {
    var to = _a.to;
    var _b = useState(false), mounted = _b[0], setMounted = _b[1];
    useEffect(function () { setMounted(true); }, []);
    return mounted ? _jsx(Navigate, { to: to, replace: true }) : null;
};
import './App.css';
import NavBar from './components/NavBar';
import HomePage from './components/HomePage';
import AdminPanel from './components/AdminPanel';
import CartModal from './components/CartModal';
import { CartProvider } from './context/CartContext';
import { useProducts } from './hooks/useS3Products';
import { useAuth } from './hooks/useAuth';
import RedaktorPage from './components/RedaktorPage';
import LabelsPage from './components/LabelsPage';
import EventsPage from './components/EventsPage';
import CalendarPage from './components/CalendarPage';
var PATH_TO_TAB = {
    '/': 'about',
    '/shop': 'shop',
    '/gallery': 'gallery',
    '/find-us': 'find-us',
    '/calendar': 'calendar',
    '/special-events': 'special-events',
};
function HomeShell() {
    var _a;
    var location = useLocation();
    var activeTab = (_a = PATH_TO_TAB[location.pathname]) !== null && _a !== void 0 ? _a : 'about';
    var _b = useState(false), showAdminPanel = _b[0], setShowAdminPanel = _b[1];
    var _c = useState('bg'), language = _c[0], setLanguage = _c[1];
    var _d = useProducts(), products = _d.products, loading = _d.loading, error = _d.error, usingFallback = _d.usingFallback, refreshProducts = _d.refreshProducts;
    var _e = useAuth(), isAuthenticated = _e.isAuthenticated, user = _e.user;
    React.useEffect(function () {
        document.body.style.overflow = '';
        document.body.style.position = '';
        return function () {
            document.body.style.overflow = '';
            document.body.style.position = '';
        };
    }, []);
    var onLanguageChange = function (lang) { return setLanguage(lang); };
    return (_jsx(CartProvider, { children: _jsxs("div", { className: "App", children: [_jsx(NavBar, { activeTab: activeTab, language: language, onLanguageChange: onLanguageChange }), _jsx(CartModal, { language: language }), isAuthenticated && (user === null || user === void 0 ? void 0 : user.role) === 'redaktor' && (_jsx("button", { className: "admin-button", onClick: function () { return setShowAdminPanel(true); }, title: "Manage Wine Products", children: "\uD83C\uDF77 Admin" })), _jsx(HomePage, { activeTab: activeTab, language: language, products: products, loading: loading, error: error, usingFallback: usingFallback, refreshProducts: refreshProducts, onTabClick: function () { } }), showAdminPanel && (_jsx(AdminPanel, { onClose: function () { return setShowAdminPanel(false); } }))] }) }));
}
function ScrollToTop() {
    var pathname = useLocation().pathname;
    useEffect(function () {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}
var App = function () {
    return (_jsxs(_Fragment, { children: [_jsx(ScrollToTop, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomeShell, {}) }), _jsx(Route, { path: "/shop", element: _jsx(HomeShell, {}) }), _jsx(Route, { path: "/gallery", element: _jsx(HomeShell, {}) }), _jsx(Route, { path: "/find-us", element: _jsx(HomeShell, {}) }), _jsx(Route, { path: "/about", element: _jsx(ClientRedirect, { to: "/" }) }), _jsx(Route, { path: "/redaktor", element: _jsx(RedaktorPage, {}, "redaktor") }), _jsx(Route, { path: "/labels", element: _jsx(LabelsPage, {}, "labels") }), _jsx(Route, { path: "/special-events", element: _jsx(EventsPage, {}, "special-events") }), _jsx(Route, { path: "/calendar", element: _jsx(CalendarPage, {}, "calendar") }), _jsx(Route, { path: "*", element: _jsx(ClientRedirect, { to: "/" }) })] })] }));
};
export default App;
